import { render, staticRenderFns } from "./coupons-section.vue?vue&type=template&id=42b109a2&scoped=true&"
import script from "./coupons-section.vue?vue&type=script&lang=js&"
export * from "./coupons-section.vue?vue&type=script&lang=js&"
import style0 from "./coupons-section.vue?vue&type=style&index=0&id=42b109a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b109a2",
  null
  
)

export default component.exports